import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, { FC, useState } from 'react';
import { IconType } from '../../enums/IconType';
import Icon from '../icon/Icon';
import styles from "./IconButton.module.scss";

export type IconButtonDesign = "dark" | "light" | "transparent";

export type IconButtonSize = 48 | 40 | 32 | 24 | 20;

interface IconButtonProps{
    onClick?: ()=>void;
    
    design?: IconButtonDesign;
    size?: IconButtonSize;
    icon?: IconType;
    iconFa?: IconProp;
    disabled?: boolean;

    offsetLeft?: 'normal';
    display?: "inline" | "inline-block" | "block";
    type?: "button" | "reset" | "submit";
    className?: string;
}

export const IconButton: FC<IconButtonProps> = ({
    onClick,

    design = "dark",
    size = 20,
    display = "inline",
    icon,
    iconFa,
    disabled = false,

    offsetLeft,
    type = 'button',
    className,
}) => {

    const [isHover, setIsHover] = useState<boolean>(false);

    return (
        <button
            className={classNames(
                styles.btn,
                styles.IconBtn,
                styles[`IconBtn__${design}`],
                styles[`IconBtn__${display}`],
                styles[`IconBtn__size${size}`],
                offsetLeft && styles[`btn__offsetLeft${offsetLeft}`],
                isHover && styles.IconBtn__hover,
                
                className && className
            )}
            type={type}
            disabled={disabled}
            onClick={onClick}
            onMouseOver={()=>setIsHover(true)}
            onMouseLeave={()=>setIsHover(false)}
        >
            {icon && <Icon icon={icon} isWhite={design==='dark' && !isHover} />}
            {iconFa && <FontAwesomeIcon icon={iconFa} />}
        </button>
    );
}
export default IconButton;